const FilterInit = () => {
    const filter = document.querySelector(".filter");
    if(!filter) return false;
    const filterWrapper = filter.querySelector(".filter__wrapper");
    const reset = filter.querySelector(".filter__reset");
    const url = filter.getAttribute("action");
    const oc = filter.querySelector(".filter__btn");
    //console.log(url);

    filter.querySelectorAll('select').forEach(select => {
        select.addEventListener('change', async function (e) {
            //console.log('1234');
            const formData = new FormData(filter);
            try {
                const response = await fetch("/classes/ajax/filter/init.php", {
                    method: "POST",
                    // body: Array.from(formData.entries()).map(([name, value]) => ({ name, value })),
                    body: formData,
                    // headers: { "Content-Type": "application/json" }
                });
                filterWrapper.innerHTML = await response.text();
                //console.log(response.text());
                FilterInit();

            } catch (error) {
                console.error('error:', error);
            } finally {

            }
        });
    });

    reset?.addEventListener("click", () => {
        window.location.href = url;
    });
    // oc?.addEventListener("click", (e) => {
    //     e.preventDefault();
    //     var wrapper = filter.querySelector(".filter__swrapper");
    //     if (wrapper.classList.contains('open')) {
    //         wrapper.classList.remove('open');
    //         wrapper.classList.add('close');
    //     } else if (wrapper.classList.contains('close')) {
    //         wrapper.classList.remove('close');
    //         wrapper.classList.add('open');
    //     }
    // });

    if(document.querySelector('.filter')){
        document.querySelector('.filter__btn').addEventListener('click', (e) => {
            e.preventDefault();
            document.querySelector('.filter__swrapper').slideToggle(200, function (){
                document.querySelector('.filter__swrapper').classList.toggle('filter__wrapper_open');
            });
        });
    }

};

export default FilterInit;